const root = process.env.REACT_APP_API_GRAPHQL;

const ContactenosRoute =
  root + "?query={accontactenos{titulo informacion{html} bag{contentItems{... on TituloDescripcion{title description{html}}}}}}";

export default ContactenosRoute;
